module.exports = __webpack_public_path__ + "img/logo-original.da60a00e.png";